/**
 * Shared Loading State Component
 */

import React from 'react';
import { Card, Flex, useTheme } from '@fti/design-system';

export function LoadingState({ message = 'Loading...' }: { message?: string }) {
  const { theme } = useTheme();

  return (
    <Card variant="outlined" padding="lg">
      <Flex direction="column" align="center" gap="sm">
        <div style={{
          width: '24px',
          height: '24px',
          border: `3px solid ${theme.colors.border.default}`,
          borderTopColor: theme.colors.primary[500],
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }} />
        <span style={{ color: theme.colors.text.secondary, fontSize: '0.9rem' }}>
          {message}
        </span>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </Flex>
    </Card>
  );
}
